import { render } from "./ProfileTypesLoader.vue?vue&type=template&id=653f76e8&ts=true"
import script from "./ProfileTypesLoader.vue?vue&type=script&lang=ts"
export * from "./ProfileTypesLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__